// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"294":"8a5bc094","315":"c0b083a1","787":"ab7e84c9","923":"f7614c6b"}[chunkId] + ".chunk.js";
};